import { useT } from "@transifex/react";

const NewClassMemberBadge = () => {
    const t = useT();
    const t_new = t("New", { _tags: "SchoolClasses, NewClassMemberBadge" });

    return (
        <span
            data-testid="class-member-new-badge"
            className="inline-flex items-center rounded-pill border border-p6-orange-brighter bg-p6-orange-light-pastel px-s py-xxs text-m font-semibold text-p6-orange-darker leading-tight shrink-0"
        >
            {t_new}
        </span>
    );
};

export default NewClassMemberBadge;
